import { useCallback } from 'react';
import { formatPlayerDataForCSV, formatPlayerHistoryForCSV, downloadCSV, generateFilename } from '../utils/csvUtils';
import { usePlayer } from '../context/PlayerContext';

export const useCSVDownload = (sessionName = null) => {
  const { players } = usePlayer();

  const downloadAllPlayersCSV = useCallback(() => {
    if (players.length === 0) {
      alert('No players data to download');
      return;
    }

    const csvData = formatPlayerDataForCSV(players);
    const filename = generateFilename('poker_players', null, sessionName);
    downloadCSV(csvData, filename);
  }, [players, sessionName]);

  const downloadPlayerHistoryCSV = useCallback((player) => {
    if (!player) {
      alert('Player not found');
      return;
    }

    if (!player.buyInHistory || player.buyInHistory.length === 0) {
      alert(`No buy-in history found for ${player.name}`);
      return;
    }

    const csvData = formatPlayerHistoryForCSV(player);
    const filename = generateFilename('buyin_history', player.name, sessionName);
    downloadCSV(csvData, filename);
  }, [sessionName]);

  const downloadFilteredPlayersCSV = useCallback((filteredPlayers) => {
    if (filteredPlayers.length === 0) {
      alert('No players data to download');
      return;
    }

    const csvData = formatPlayerDataForCSV(filteredPlayers);
    const filename = generateFilename('filtered_poker_players', null, sessionName);
    downloadCSV(csvData, filename);
  }, [sessionName]);

  return {
    downloadAllPlayersCSV,
    downloadPlayerHistoryCSV,
    downloadFilteredPlayersCSV
  };
};